import { Alert, Group, Text } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'
import { useAppInfo } from 'hooks/info'

export function DevBanner() {
  const { data } = useAppInfo()
  const isProdDb = data?.env === 'prod'

  return (
    <Alert
      variant="filled"
      color={isProdDb ? 'red' : 'yellow'}
      radius={0}
      styles={{
        root: { height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' },
      }}
    >
      <Group>
        {isProdDb && <IconAlertTriangle size={18} />}
        <Text size="sm" fw={700} ta="center">
          Development Environment
          {isProdDb && ' — CONNECTED TO PRODUCTION DATABASE!'}
        </Text>
        {isProdDb && <IconAlertTriangle size={18} />}
      </Group>
    </Alert>
  )
}
